import { Action } from '@ngrx/store';
import { Workstep } from '../../../_models/workstep';

export enum WorkstepActitonTypes {
  ClearWorkstep = '[Workstep] Clear',
  InicializeWorkstep = '[Workstep] Inicialize',
  SetCurrentWorkstep = '[Workstep] Set Current',
  SetFilterFields = '[Workstep] Set Filter Fields',

  SetStaticModal = '[OrderPlanned] Set Static Modal',

  LoadWorksteps = '[Workstep] Load',
  LoadWorkstepsSuccess = '[Workstep] Load Success',
  LoadWorkstepsFail = '[Workstep] Load Fail',

  CreateWorkstep = '[Workstep] Create',
  CreateWorkstepSuccess = '[Workstep] Create Success',
  CreateWorkstepFail = '[Workstep] Create Fail',

  UpdateWorkstep = '[Workstep] Update',
  UpdateWorkstepSuccess = '[Workstep] Update Success',
  UpdateWorkstepFail = '[Workstep] Update Fail',

  DeleteWorkstep = '[Workstep] Delete',
  DeleteWorkstepSuccess = '[Workstep] Delete Success',
  DeleteWorkstepFail = '[Workstep] Delete Fail',
}

export class ClearWorkstep implements Action {
  readonly type = WorkstepActitonTypes.ClearWorkstep;
}

export class InicializeWorkstep implements Action {
  readonly type = WorkstepActitonTypes.InicializeWorkstep;
}

export class SetCurrentWorkstep implements Action {
  readonly type = WorkstepActitonTypes.SetCurrentWorkstep;
  constructor(public payload: Workstep) {
  }
}

export class SetFilterFields implements Action {
  readonly type = WorkstepActitonTypes.SetFilterFields;
  constructor(public payload: any) { }
}

export class SetStaticModal implements Action {
  readonly type = WorkstepActitonTypes.SetStaticModal;
  constructor(public payload: boolean) { }
}

export class LoadWorksteps implements Action {
  readonly type = WorkstepActitonTypes.LoadWorksteps;
  constructor(public payload: any) { }
}

export class LoadWorkstepsSuccess implements Action {
  readonly type = WorkstepActitonTypes.LoadWorkstepsSuccess;
  constructor(public payload: Workstep[]) { }
}

export class LoadWorkstepsFail implements Action {
  readonly type = WorkstepActitonTypes.LoadWorkstepsFail;
  constructor(public payload: string) { }
}

export class CreateWorkstep implements Action {
  readonly type = WorkstepActitonTypes.CreateWorkstep;
  constructor(public payload: any) { }
}

export class CreateWorkstepSuccess implements Action {
  readonly type = WorkstepActitonTypes.CreateWorkstepSuccess;
  constructor(public payload: Workstep) { }
}

export class CreateWorkstepFail implements Action {
  readonly type = WorkstepActitonTypes.CreateWorkstepFail;
  constructor(public payload: string) { }
}

export class UpdateWorkstep implements Action {
  readonly type = WorkstepActitonTypes.UpdateWorkstep;
  constructor(public payload: any) { }
}

export class UpdateWorkstepSuccess implements Action {
  readonly type = WorkstepActitonTypes.UpdateWorkstepSuccess;
  constructor(public payload: Workstep) { }
}

export class UpdateWorkstepFail implements Action {
  readonly type = WorkstepActitonTypes.UpdateWorkstepFail;
  constructor(public payload: string) { }
}

export class DeleteWorkstep implements Action {
  readonly type = WorkstepActitonTypes.DeleteWorkstep;
  constructor(public payload: Workstep) { }
}

export class DeleteWorkstepSuccess implements Action {
  readonly type = WorkstepActitonTypes.DeleteWorkstepSuccess;
  constructor(public payload: bigint) { }
}

export class DeleteWorkstepFail implements Action {
  readonly type = WorkstepActitonTypes.DeleteWorkstepFail;
  constructor(public payload: string) { }
}

export type WorkstepActions =
  ClearWorkstep
| InicializeWorkstep
| SetCurrentWorkstep
| SetFilterFields
| SetStaticModal

| LoadWorksteps
| LoadWorkstepsSuccess
| LoadWorkstepsFail

| CreateWorkstep
| CreateWorkstepSuccess
| CreateWorkstepFail

| UpdateWorkstep
| UpdateWorkstepSuccess
| UpdateWorkstepFail

| DeleteWorkstep
| DeleteWorkstepSuccess
| DeleteWorkstepFail;
